import { Api } from '@/api/api';
import { Environment } from '@/shared/environment';

export class EnvironmentApi extends Api {
    public async fetchAsync(): Promise<Environment> {
        return await this.getAsync<Environment>('v1/environment');
    }

    public constructor() {
      super();
  }
}
